import BackButton from 'components/backButton'
import { MasterDataUpdateForm } from 'components/masterData'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { fetchMasterDataById } from 'utils/api/masterDataApi'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { PAGE_NOT_FOUND } from 'utils/constants'
import { Spinner } from 'components/common'

const MasterDataUpdate = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [catalogue, setCatalogue] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState<boolean>(true)

  const handleBack = () => {
    navigate(-1)
  }

  const getMasterDataCatalogue = async (id: string) => {
    try {
      const { data } = await fetchMasterDataById(id)
      setCatalogue({ ...data })
    } catch (error) {
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  // To initially fetech Master data if id is present
  useEffect(() => {
    if (id) {
      getMasterDataCatalogue(id)
    }
  }, [])

  if (loading) {
    return <Spinner />
  }

  return (
    <>
      <Helmet>
        <title>ORMS Update Master Data</title>
      </Helmet>

      <BackButton handleBack={handleBack} />

      {catalogue && (
        <>
          <h1 className="py-3 text-lg font-bold">{catalogue?.description}</h1>
          <MasterDataUpdateForm catalogue={catalogue} />{' '}
        </>
      )}
    </>
  )
}

export default MasterDataUpdate
